import React, { useState, useEffect } from 'react';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PaymentsAPI from 'api/PaymentsAPI';

interface IDowngradeNotice {
  subInfo: any;
}

const DowngradeNotice: React.FC<IDowngradeNotice> = ({ subInfo }) => {
  const [ downgradeSchedule, setDowngradeSchedule ] = useState<any>({ isLoading: true, data: {} });

  const getSubSchedule = async(sched_id: string) => {
    if (sched_id) {
      const upcomingSchedule = await PaymentsAPI.getSubSchedule(sched_id);
      if (upcomingSchedule?.success) {
        setDowngradeSchedule({ isLoading: false, data: upcomingSchedule });
      }
    } else {
      setDowngradeSchedule({ isLoading: false, data: {} });
    }
  };

  const releaseFromSchedule = async() => {
    const released = await PaymentsAPI.releaseSubSchedule(downgradeSchedule.data.result.id);
    if (released?.success) {
      history.go(0);
    }
  };

  useEffect(() => {
    getSubSchedule(subInfo.schedule);
  }, [ subInfo ]);

  return (
    <div className='no-api-container'>
      <div className='no-api-body'>
        <div
          className='no-api-msg-container'
          style={{ border: '1px solid #4895EF', background: 'rgba(72, 149, 239, 0.15)' }}
        >
          <div className='down-notice-msg-text-body'>
            <AccessTimeIcon fontSize='large' style={{ color: 'white' }} />
            <div className='no-api-msg-text-style'>
              You currently have a plan downgrade scheduled. To make any further changes to your subscription, please click &apos;Cancel Downgrade&apos;.
            </div>
            <div
              className='plan-upgrade-btn'
              style={{ width: '250px' }}
              onClick={() => releaseFromSchedule()}
            >
              <div className='plan-upgrade-btn-spacing'>
                <div className='plan-upgrade-btn-text'>
                  Cancel Downgrade
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DowngradeNotice;
